
import OutletClassService from './OutletClassService';

export { default } from './OutletClassService';
export const outletClassService = new OutletClassService();